<script>
  import UserDetailsView from "../components/UserDetailsView.svelte";

  export let f7route;
  export let f7router;
</script>

<UserDetailsView
  {f7route}
  {f7router}
  pageTitle="Incomplete User Details"
  primaryStorageKey="incomplete_user_data"
/>
